import React from 'react';
import ProductPage from './ProductPage';

export default function LeadShield() {
  return (
    <ProductPage
      badge="⤶ Lead Shield · NEW"
      title="Fake leads stop"
      titleAccent="before your CRM"
      subtitle="Every form submission runs through 2,000+ fraud checks and gets a risk score. Spam, bots, and competitor noise are flagged so your sales team only follows up on real humans."
      features={[
        { icon: '📝', title: 'Form-level verdict', body: 'Attach to any form — HubSpot, Marketo, Pardot, custom. Each submission gets a verdict and risk score.' },
        { icon: '🎯', title: 'Smart routing', body: 'Push clean leads straight to your CRM. Quarantine suspicious ones for review. Discard obvious junk.' },
        { icon: '🧠', title: 'Behavioural scoring', body: 'Looks at how the form was filled — paste patterns, keystroke cadence, time on page — not just the email string.' },
        { icon: '📧', title: 'Email risk check', body: 'Catches disposables, free-mail at B2B forms, mistyped domains, and syntactically-valid but unreachable mailboxes.' },
        { icon: '◉', title: 'IP context', body: 'Carries over verdicts from PPC Shield — if the IP was flagged on an ad click, the form submission is pre-scored.' },
        { icon: '🔗', title: 'HubSpot &amp; Zapier webhooks', body: 'Verdicts delivered to your CRM as hidden properties — no custom integration work.' },
      ]}
      stats={[
        { value: '34%', label: 'of B2B form submissions are low-quality' },
        { value: '2,000+', label: 'checks per submission' },
        { value: '7 min', label: 'typical setup time' },
        { value: '0ms', label: 'added to form submit UX' },
      ]}
      ctaTitle="Give your sales team real leads"
      ctaBody="Stop wasting SDR time on fake form fills. Lead Shield pays for itself the first week."
    />
  );
}
